import { atomFamily } from 'recoil';

var currentFolderIdState = atomFamily({
    key: "BreadcrumbCurrentFolderIdState",
    "default": undefined
});
var currenFolderRootIdState = atomFamily({
    key: "BreadcrumbCurrenFolderRootIdState",
    "default": undefined
});
var foldersVisibleState = atomFamily({
    key: "BreadcrumbFoldersVisibleState",
    "default": false
});
var foldersState = atomFamily({
    key: "BreadcrumbFolderState",
    "default": undefined
});

export { currenFolderRootIdState, currentFolderIdState, foldersState, foldersVisibleState };
//# sourceMappingURL=atoms.js.map
